import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPackageBuyers } from '@/features/vendor/api/commissions';
import { Users, ArrowRight } from 'lucide-react';
import { formatJalaliDateTime } from '@/lib/format';

const toPersianDigits = (str) => {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return str.toString().replace(/\d/g, (d) => persianDigits[d]).replace(/\./g, '٫');
};

const fmt = (n) => {
    const num = Number(n) || 0;
    return toPersianDigits(new Intl.NumberFormat('en-US').format(num));
};

const formatDate = formatJalaliDateTime;

export default function VendorPackageBuyersPage() {
    const { packageId } = useParams();
    const navigate = useNavigate();
    const [buyers, setBuyers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchBuyers = async () => {
            try {
                const res = await getPackageBuyers(packageId);
                setBuyers(res);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchBuyers();
    }, [packageId]);

    if (loading) return <div style={{ textAlign: 'center', padding: '3rem' }}>در حال دریافت لیست خریداران...</div>;
    if (error) return <div className="error-banner">{error}</div>;

    return (
        <div style={{ direction: 'rtl', padding: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem', gap: '1rem', background: '#fff', padding: '1rem 1.5rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                <h1 style={{ margin: 0, fontSize: '1.2rem', color: '#1e293b', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <Users size={22} color="#2563eb" />
                    لیست خریداران پکیج
                </h1>

                <button
                    onClick={() => navigate('/vendor/reports')}
                    style={{
                        marginRight: 'auto',
                        background: '#2563eb', color: '#fff', border: 'none',
                        padding: '0.5rem 1.2rem', borderRadius: '8px', fontWeight: 'bold',
                        cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.9rem'
                    }}
                >
                    <ArrowRight size={16} /> بازگشت به گزارشات
                </button>
            </div>

            <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                        <thead style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                        <tr>
                            <th style={{ padding: '1rem', color: '#475569', fontWeight: 'bold' }}>نام خریدار</th>
                            <th style={{ padding: '1rem', color: '#475569', fontWeight: 'bold' }}>معرف</th> {/* 👈 ستون جدید */}
                            <th style={{ padding: '1rem', color: '#475569', fontWeight: 'bold' }}>شماره تماس</th>
                            <th style={{ padding: '1rem', color: '#475569', fontWeight: 'bold' }}>تاریخ خرید</th>
                            <th style={{ padding: '1rem', color: '#475569', fontWeight: 'bold' }}>مبلغ خرید</th>
                        </tr>
                        </thead>
                        <tbody>
                        {buyers.map((buyer, idx) => (
                            <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                <td style={{ padding: '1rem', color: '#1e293b', fontWeight: 'bold' }}>{buyer.buyer_name}</td>
                                {/* 👈 نمایش نام معرف */}
                                <td style={{ padding: '1rem', color: '#2563eb', fontWeight: 'bold' }}>
                                        <span style={{ background: '#eff6ff', padding: '0.2rem 0.6rem', borderRadius: '6px' }}>
                                            {buyer.referrer_name}
                                        </span>
                                </td>
                                <td style={{ padding: '1rem', color: '#1e293b', direction: 'ltr', textAlign: 'center' }}>{toPersianDigits(buyer.buyer_mobile)}</td>
                                <td style={{ padding: '1rem', color: '#475569' }}>{formatDate(buyer.created_at)}</td>
                                <td style={{ padding: '1rem', color: '#059669', fontWeight: 'bold' }}>{fmt(buyer.total_amount)} ریال</td>
                            </tr>
                        ))}
                        {buyers.length === 0 && (
                            <tr>
                                <td colSpan="5" style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>
                                    هنوز هیچ‌کس این پکیج را خریداری نکرده است.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}